
import Vue from 'vue'
import Skeleton from '@/common/components/Skeleton.vue'

export default Vue.extend({
  components: {
    Skeleton
  },
  props: {
    detail: {
      type: String,
      required: true
    },
    loaded: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      isShowMoreDetails: false,
      isContentLong: null
    }
  },
  watch: {
    loaded() {
      this.checkContentLength()
    }
  },
  methods: {
    toggleShowMoreDetails() {
      this.isShowMoreDetails = !this.isShowMoreDetails
    },
    checkContentLength() {
      this.$nextTick(() => {
        if (!this.$refs.hiddenDiv) return
        const divHeight = this.$refs.hiddenDiv.offsetHeight
        this.isContentLong = divHeight > 100
      })
    }
  }
})
